<template>
	<div id="analysisContainer" class="neighbor-analysis-container">
		<div class="map-header-sec">
			<div class="header5">Neighborhood</div>
			<div class="header3">Analysis</div>
		</div>
		<div class="results-sec">
			<div class="card-cont card">
				<PropMapInfoElement v-bind:mapInfoValue="property.township" mapInfoLabel="Township" mapIconName="township.svg" />
				<PropMapInfoElement
					v-bind:mapInfoValue="property.neighborhoodCode.toString()"
					mapInfoLabel="Neighborhood Code"
					mapIconName="neighborhood.png"
				/>
				<PropMapInfoElement
					v-bind:mapInfoValue="property.propertyClassification.toString() | propertyClassificationFormat"
					mapInfoLabel="Property Classification"
					mapIconName="property-classification.svg"
				/>
			</div>
			<div class="table-title">
				The best way to determine if your taxes are too high is to compare your property to other homes in your neighborhood. Below Garbur has
				performed an analysis of all the houses in your area to determine which are comparable to your home and where you rank in terms of
				building assessment per square foot to those houses.
			</div>
			<ComparedTable class="desktop-table" />
		</div>
	</div>
</template>

<script>
import PropMapInfoElement from "@/components/property/PropMapInfoElement.vue";
import ComparedTable from "@/components/property/ComparedTable.vue";
import Map from "@/components/Map.vue";

export default {
	name: "property-map",
	components: {
		PropMapInfoElement,
		ComparedTable,
		Map,
	},
	computed: {
		property() {
			return this.$store.getters.getAllPropertyData;
		},
		city() {
			const cityObj = this.property.propertySummary.city;
			if (cityObj) {
				return this.property.propertySummary.city;
			} else {
				return "";
			}
		},
	},
};
</script>

<style scoped lang="scss">
.neighbor-analysis-container {
	flex-direction: column;
	display: flex;
	text-align: left;
	position: relative;
	height: calc(100vh - 236px);
	max-width: 1600px;
	padding: 120px 60px 60px;

	.header5 {
		color: var(--accent);
	}
	.header3 {
		font-size: 36px;
		line-height: 36px;
		color: var(--black);
		margin-top: 8px;
	}
	.results-title {
		font-size: 25px;
		margin-bottom: 15px;
	}
	.table-title {
		font-style: normal;
		font-weight: 300;
		font-size: 16px;
		line-height: 200%;
		color: var(--text);
		margin: 30px 0;
	}
	.results-sec {
		display: grid;
		margin-top: 30px;
		grid-gap: 35px;
		grid-template-columns: auto auto;
	}
	.card-cont {
		padding: 30px 20px;
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
		max-width: 875px;
		align-items: center;
	}
}
@media screen and (max-width: 768px) {
	.neighbor-analysis-container {
		height: unset;
		.results-sec {
			display: grid;
			grid-template-columns: repeat(auto-fit, minmax(372px, 1fr));
		}
		.card-cont {
			display: grid;
			grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
			max-width: unset;
			align-items: center;
			grid-gap: 25px;
		}
	}
	.desktop-table {
		display: none;
	}
}
@media screen and (max-width: 414px) {
	.neighbor-analysis-container {
		padding: 3rem 1rem;
		.results-sec {
			display: grid;
			grid-template-columns: repeat(auto-fit, minmax(372px, 1fr));
		}
	}
}
</style>
